<template>
  <div v-if="!hiddenSection" class="mx3 p2 my2 flex flex-auto pointer action" @click="router.push({name: pathname})">
    <span class="h5n semi-bold flex items-center">{{ getReferencelabel(reference) }}</span>
    <i class="icon-angle-right-icon action-arrow flex flex-auto justify-end"></i>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed } from 'vue';

import { getReferencelabel } from '@/mixins/utils';

export default {
  props: {
    reference: {
      type: String,
      default: 'My title'
    },
    pathname: {
      type: String,
      default: 'Accueil'
    },
    path: {
      type: String,
      default: 'Accueil'
    }
  },
  setup (props) {
    const router = useRouter();
    const store = useStore();
    const hiddenSection = computed(() => {
    const navSection = store.getters.getSiteConfiguration('disabled_features');

      return !!(navSection.includes(props.path));
    });

    return { router, getReferencelabel, hiddenSection };
  }
};
</script>

<style scoped>
.action {
  border: 2px solid white;
  border-radius: 0px;
  background: white;
}

.action:hover {
  border-color: white;
  background: #00a6c6;
  color: white;
}

.action:active {
  border-color: white;
  background: #20bcdc;
  color: white;
}

.action:hover > .action-arrow  {
  color:white;
}

.action-arrow {
  font-size: 30px;
  color:red;
}

</style>
